import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'


import { useFeedbackModal } from '@features/feedback'

import { BannerApp } from '@widgets/app-banner'


import { URL_PAGE_CATALOG } from '@shared/contants'
import Button from '@shared/ui/button'
import { Toc } from '@shared/ui/toc'

import styles from './styles.module.scss'


export default function PaymentInfo () {
  const { t: t } = useTranslation('InfoPayment')
  const containerRef = useRef<HTMLDivElement>(null)
  const isMobile = useMediaQuery('(max-width: 768px)')

  const { openFeedbackModal } = useFeedbackModal()

  return (
    <div className={styles.root} ref={containerRef}>
      {isMobile && <Toc containerRef={containerRef} />}
      <div className={styles.safeguard}>
        <h3>{t('safeguard.title')}</h3>
        <p className={styles.safeguard__subtitle}>{t('safeguard.subtitle')}:</p>
        <div className={styles.safeguard__cards}>
          <div className={styles.safeguard__item}>
            <ReactSVG src="/icons/card.svg" />
            <span>{t('safeguard.card-1')}</span>
          </div>
          {/* <div className={styles.safeguard__item}>
            <ReactSVG src="/icons/mobile-vibration.svg" />
            <span>{t("safeguard.card-2")}</span>
          </div>
          <div className={styles.safeguard__item}>
            <ReactSVG src="/icons/mobile-check.svg" />
            <span>
              {t("safeguard.card-3")}
              <a href="https://Kaspi.kz" target="_blank">
                {" "}
                Kaspi.kz
              </a>
            </span>
          </div> */}
        </div>
        <div className={styles.root__description}>
          <span>
            {t('safeguard.description-first')}{ ' ' }
            <button 
              type="button"
              onClick={openFeedbackModal}
              className={styles.linkButton}
            >
              {t('safeguard.description-link')}
            </button>
            {t('safeguard.description-second')}
          </span>
        </div>
      </div>
      <div className={styles.cards}>
        <h3>{t('cards.title')}</h3>
        <div className={styles.cards__item}>
          <div className={styles.cards__img}>
            <img src="/img/info/payment/card-2.svg" alt="" />
          </div>
          <div className={styles.cards__text}>
            <span>{t('cards.1.text-1')}</span>
            <span>{t('cards.1.text-2')}</span>
            <Button to={URL_PAGE_CATALOG} size="large">
              <span>{t('cards.button')}</span>
            </Button>
          </div>
        </div>
        <div className={styles.cards__item}>
          <div className={styles.cards__img}>
            <img src="/img/info/payment/card-1.svg" alt="" />
          </div>
          <div className={styles.cards__text}>
            <span>{t('cards.2.text')}</span>
          </div>
        </div>
      </div>
      <div className={styles.payment}>
        <h3>{t('payment.title')}</h3>
        <span className={styles.payment__subtitle}>
          {t('payment.subtitle')}
        </span>
        <ol>
          <li>{t('payment.li-1')};</li>
          <li>{t('payment.li-2')};</li>
          <li>{t('payment.li-3')};</li>
          <li>{t('payment.li-4')}.</li>
        </ol>
        <div className={styles.root__description}>
          {t('payment.description')}
        </div>
      </div>
      <div className={styles.root__banner}>
        <BannerApp />
      </div>
    </div>
  )
}
